import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Heading1,
  Heading2,
  LinkStyled,
  List,
  Paragraph,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Fadoel" activeSidemenu="Flex20">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0px">
          <Heading1>Flex 20 fadøl</Heading1>
        </Col>
        <Col xs={12}>
          <Paragraph>
            Hos Skafte finder du et særligt udvalgt sortiment af Flex 20 fadølsfustager (med slange). Vær opmærksom på at disse fustager kræver eget Flex 20 anlæg, og vi udlejer ikke udstyr til denne type fustage. Flex 20 fustager lagerføres ikke, men tages hjem mod bestilling og forudbetaling. Ingen returret.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="fadoelFlex20" display={ProductView1} filterLiterSize />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Fustager til Draughtmaster Flex 20
          </Heading2>
          <Paragraph>
            Draughtmaster Flex 20 er et populært fadølssystem både i restaurationsbranchen og hos private, grundet størrelsen. Flex 20 systemet er mobilt og kan anvendes hvor der er brug for det, uanset om det er indendørs eller udendørs.
          </Paragraph>
          <Paragraph>
            Dette system er lidt mindre end den beslægtede variant, <LinkStyled to="/fadoel/modular-20">Modular 20</LinkStyled>, der har en større kapacitet.
            Flex 20 har medfølgende tappeslange til plastikfustagen.
            Vi gør opmærksom på, at Skafte desværre ikke udlejer fadølsanlæg til Flex 20 fustager.
          </Paragraph>
          <Paragraph>Flex 20 kræver specielt udstyr til tapning, men der medfølger tappeslange til fustagerne.
            Grundet trykket og Flex 20 fustagens plastikmateriale, vil fustagen blive helt fladmast, når øllet er skænket. Den brugte, flade plastik kan herefter genanvendes.
          </Paragraph>
          <Paragraph>
            Den største fordel ved Flex 20 fadølssystemet er holdbarheden. Når fustagen er brudt, kan øllet stadig holde sig frisk i op til 30 dage. Desuden vejer en Flex 20 fustage ikke ret meget, grundet materialet. Øllet leveres i 20 liters plastikfustager, hvor den samlede vægt kun er 21,2 kg, heraf vejer øllet 20 kg.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Når du bestiller en Flex 20 fustage
          </Heading2>
          <Paragraph>
            Der kræves et særligt fadølsanlæg, der passer til Draughtmaster Flex 20 og der kan ikke anvendes et almindeligt anlæg som alternativ. Skafte udlejer ikke anlæg til Flex 20.
          </Paragraph>
          <Paragraph>
            Der er pant på Flex 20 fustager: 40 kr. + moms = pant på 50 kr.
          </Paragraph>
          <Paragraph>
            Vores Flex 20 fadøl er ikke lagerført, men er en bestillingsvare. Du må derfor forvente en smule længere ventetid på ca. 5 dage, da vi skal levere fra vores fjernlager.
          </Paragraph>
          <Paragraph>
            Flex 20 fustager leveres med tappeslange.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading2>
            Vores udvalg af Flex 20 fadøl
          </Heading2>
          <Paragraph>
            Hos Skafte fører vi et lille udvalg af fadøl på Flex 20 fustage, hvor du let kan servere de skønneste ølklassikere til gæsterne.
          </Paragraph>
          <Paragraph>
            I udvalget finder du fx
          </Paragraph>
          <List>
            <li>Carlsberg Pilsner</li>
            <li>Grøn Tuborg</li>
            <li>Tuborg Classic</li>
          </List>
          <Paragraph>
            Alle Flex 20 fustager har et indhold på 20 liter.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white>
      <Row>
        <Col xs={12}>
          <Heading2>
            Sådan fungerer Flex 20
          </Heading2>
          <Paragraph>
            Flex 20 er populært blandt mindre steder i restaurationsbranchen samt hos private. Der er indbygget kølesystem i anlægget og det er ikke nødvendigt med rengøring af slangerne.
          </Paragraph>
          <Paragraph>
            Princippet er, at Flex 20 fadølsfustagen sættes i en beholder, hvor der herefter pumpes trykluft i mellemrummet mellem plastikfustagen og beholdervæggen. Trykket gør, at øllet pumpes ud af fustagen.
            Så snart Flex 20 er tom, åbnes trykbeholderen (først &quot;piftes&quot; den) og den nu helt sammentrykkede plastikfustage tages ud og erstattes med en ny.
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
